import { render } from "./NotificationModal.vue?vue&type=template&id=701e66e0&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=js"
export * from "./NotificationModal.vue?vue&type=script&lang=js"

import "./NotificationModal.vue?vue&type=style&index=0&id=701e66e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701e66e0"]])

export default __exports__